import React, { Component } from 'react';
import LoadingEffect from '../commons/LoadingEffect';

export default class ConsignorHomeLoading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static renderLoadingEffect(align, width) {
    return (
      <td align={`${align}`} aria-label="Loading">
        <LoadingEffect width={`${width}`} height="height-loading" />
      </td>
    );
  }

  static renderTr(string) {
    return (
      <tr>
        {ConsignorHomeLoading.renderLoadingEffect('right', 'width-new')}
        {ConsignorHomeLoading.renderLoadingEffect('', `${string}`)}
      </tr>
    );
  }

  render() {
    return (
      <div className="mui" id="pageFrame">
        <div id="pageBody">
          <div id="contentWrapper">
            {/* main content - start */}
            <table border="0" cellPadding="0" cellSpacing="5" aria-label="Loading consignor form">
              <tbody>
                <tr>
                  <td aria-hidden="true">&nbsp;</td>
                </tr>
                <tr>
                  {ConsignorHomeLoading.renderLoadingEffect('right', 'width-new')}
                  {ConsignorHomeLoading.renderLoadingEffect('', 'width-consignor')}
                  {ConsignorHomeLoading.renderLoadingEffect('', 'width-new')}
                </tr>
                {ConsignorHomeLoading.renderTr('width-consignorID')}
                {ConsignorHomeLoading.renderTr('width-group')}
                {ConsignorHomeLoading.renderTr('width-name')}
                {ConsignorHomeLoading.renderTr('width-ratio')}
                {ConsignorHomeLoading.renderTr('width-ratio')}
                <tr>
                  <td colSpan="3" aria-hidden="true">
                    &nbsp;
                  </td>
                </tr>
                <tr>
                  <td colSpan="3" aria-label="Loading save button">
                    <LoadingEffect width="width-saveChanges" height="height-loading" />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* main content - end */}
          </div>
        </div>
      </div>
    );
  }
}
